import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid'

// components
import { SectionHeader } from "../../components/layouts/section.header";
import { TableSearchJobs } from "../../tables/search.jobs";
import { BadgeServiceType } from "../../components/commons/badge.service.type";
import { BadgeServiceStatus } from "../../components/commons/badge.service.status";
import { BadgePremiseType } from "../../components/commons/badge.premise.type";
import { BadgePremisePhaseType } from "../../components/commons/badge.premise.phase.type";

// forms
import { FormTextInput } from "../../components/forms/textinput";

// drawer
import { DrawerPartnerUploadedDocument } from "../../components/drawers/partner.uploaded.document";

// reducers
import { fetchJobServiceDetails, resetJobReports } from "../../stores/jobs";
import { resetJobSearch, searchJobsByJobId } from "../../stores/jobs.search";

// utilities
import { classNames } from "../../utilities";

export const ScreenJobHome = () => {

  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { items = [] } = useSelector(context => context.jobsSearch);

  // forms
  const form = useForm({
    defaultValues: {
      job_id: '',
    }
  });

  const onSubmitSearch = async (data) => {
    console.log('onSubmitSearch', data);
    try {
      // vat
      let nextToken = null;

      // reset first
      dispatch(resetJobSearch());

      do {
        const res = await dispatch(searchJobsByJobId({
          job_id: data.job_id,
          next_token: nextToken,
        })).unwrap();
        console.log('onSubmitSearch', 'res', res);

        nextToken = res.nextToken;
      } while (nextToken);

      
    } catch (err) {
      console.error('onSubmitSearch', err);
    } finally {

    }
  }

  return (
    <>
      <Helmet>
        <title>Job: Home</title>
      </Helmet>
      <div className="py-8 h-screen w-full">

        {/* Header */}
        <div className="pb-8 px-4 grid grid-cols-10 gap-4">

          <div className="col-span-6 flex flex-col justify-between items-start">
            <div className="flex flex-row justify-start items-center">
              <SectionHeader title={'Jobs'} />
            </div>
          </div>
        </div>

        {/* BODY */}
        <div className="h1-full grid grid-cols-12 gap-4">

          {/* WORKING */}
          <div className="col-span-12 px-4 py-4">
            <div className='w-full p-4 bg-slate-100 rounded-md'>
              <h3 className="text-xl text-slate-700 font-bold">Search Job</h3>
              <p className="text-base text-slate-500 font-regular">Enter Job Identifier (e.g. 170230013)</p>
              <div className="pt-4">
                
                <div className="flex flex-row">
                  <FormTextInput 
                    form={form}
                    name={'job_id'}
                    rules={{required: 'Job Identifier is required.'}}
                    placeholder={'Job Identifier'}
                    containerclassstyle='mr-2'
                  />

                  <button
                    type="button"
                    className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:shadow-none dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500"
                    onClick={form.handleSubmit(onSubmitSearch)}
                    
                  >
                    <MagnifyingGlassIcon aria-hidden="true" className="size-5" />
                  </button>
                </div>
                
              </div>
            </div>

            {/* SECTION OUTLET */}
            {items.length > 0 &&
              <div className="py-8">
                <TableSearchJobs />
              </div>
            }
            
          </div>
        </div>
        
      </div>
    </>
  );
};